// @ts-nocheck
export default {
    SET_REMITTANCE(state, remittance) {
        state.remittance.data = remittance;
    },
    SET_REMITTANCE_RECEIVER(state, receiver) {
        state.remittance.receiver = receiver;
    },
};
